const YMMKofferbakmatten = (() => {

  function _getContainer() {
    return document.getElementById('autotype-kofferbakmatten');
  }

  function _parseIndex(container) {
    try {
      return JSON.parse(container.dataset.autotypeIndex ?? '{}');
    } catch (e) {
      console.error('YMMKofferbakmatten: autotype index JSON ongeldig', e);
      return {};
    }
  }

  function _parseAutotypesMap(container) {
    try {
      return JSON.parse(container.dataset.autotypesMap ?? '[]');
    } catch (e) {
      console.error('YMMKofferbakmatten: autotypes map JSON ongeldig', e);
      return [];
    }
  }

  function _updateBadges(container, index, handle) {
    const slides = container.querySelectorAll('.autotype-kofferbakmatten__slide[data-product-id]');
    slides.forEach(slide => {
      const productId = slide.dataset.productId;
      const handles = index[productId] ?? [];

      slide.classList.remove('autotype-match', 'autotype-no-match');

      if (handles.includes(handle)) {
        slide.classList.add('autotype-match');
      } else {
        slide.classList.add('autotype-no-match');
      }
    });
  }

  function _updateTitle(container, autotypesMap, handle) {
    const titleEl = document.getElementById('autotype-kofferbakmatten-title');
    if (!titleEl) return;
    const baseTitle = titleEl.dataset.baseTitle ?? '';
    const matchedAutotype = autotypesMap.find(a => a.handle === handle);
    if (matchedAutotype) {
      titleEl.textContent = baseTitle + ' ' + matchedAutotype.volledige_naam;
    } else {
      titleEl.textContent = baseTitle;
    }
  }

  function init() {
    const container = _getContainer();
    if (!container) return;

    const stored = YMMStorage.get();
    if (!stored?.handle) return;

    const index = _parseIndex(container);
    const autotypesMap = _parseAutotypesMap(container);

    _updateTitle(container, autotypesMap, stored.handle);
    _updateBadges(container, index, stored.handle);
  }

  function update(handle) {
    if (!handle) return;

    const container = _getContainer();
    if (!container) return;

    const index = _parseIndex(container);
    const autotypesMap = _parseAutotypesMap(container);

    _updateTitle(container, autotypesMap, handle);
    _updateBadges(container, index, handle);
  }

  function reset() {
    const container = _getContainer();
    if (!container) return;

    const slides = container.querySelectorAll('.autotype-kofferbakmatten__slide[data-product-id]');
    slides.forEach(slide => {
      slide.classList.remove('autotype-match', 'autotype-no-match');
    });

    const titleEl = document.getElementById('autotype-kofferbakmatten-title');
    if (titleEl) titleEl.textContent = titleEl.dataset.baseTitle ?? '';
  }

  return { init, update, reset };

})();

document.addEventListener('DOMContentLoaded', () => {
  YMMKofferbakmatten.init();
});

document.addEventListener('ymm:autotype-selected', (e) => {
  const { handle } = e.detail;
  if (handle) YMMKofferbakmatten.update(handle);
});

document.addEventListener('ymm:autotype-forgotten', () => {
  YMMKofferbakmatten.reset();
});
